import { Layout, Typography, Button, Select } from 'antd';
import classes from './ConfirmRegistration.module.scss';
import { useTranslation } from 'react-i18next';
import RegistrationTimeline from '../../components/RegistrationTimeline/RegistrationTimeline';
import { languagesValues } from 'routes/Main/Main';
import LogoType from 'assets/img';
import { useSearchParams, useNavigate } from 'react-router';
import { useState, useEffect } from 'react';
import auth from 'api/auth';
import { useAppSelector } from 'store/hook';

const { Title } = Typography;

export default function ConfirmRegistration() {
  const { messageApi } = useAppSelector((store) => store.windowState);  

  const { t, i18n } = useTranslation();
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const email = searchParams.get('email');
  const language = localStorage.getItem('language') || 'en';
  const [isResending, setIsResending] = useState(false);
  const [countdown, setCountdown] = useState(0);

  const onLanguageChange = (value: string) => {
    localStorage.setItem('language', value);
    i18n.changeLanguage(value);
  };

  useEffect(() => {
    let timer: NodeJS.Timeout;
    if (countdown > 0) {
      timer = setTimeout(() => setCountdown(countdown - 1), 1000);
    }
    return () => clearTimeout(timer);
  }, [countdown]);

  const handleResendEmail = async () => {
    if (!email) {
      messageApi?.error(t('confirmRegistration.errors.noEmail'));
      return;
    }

    setIsResending(true);
    try {
      await auth.resendConfirmationLink({ email });
      messageApi?.success(t('confirmRegistration.success.emailResent'));
      setCountdown(60); 
    } catch (error: any) {
      messageApi?.error(t('confirmRegistration.errors.resendFailed'));
    } finally {
      setIsResending(false);
    }
  };

  const handleFaqClick = () => {
    navigate('/ref');
  };

  return (
    <div className={classes.mainWrap}>
      <Layout className={classes.confirmElem}>
        <Select
          className={classes.localizationSelect}
          defaultValue={language}
          onChange={onLanguageChange}
          style={{ minWidth: 130 }}
          options={languagesValues}
          optionLabelProp={'label'}
        />

        <div className={classes.confirmCard}>
          <RegistrationTimeline currentStep={1} />

          <div className={classes.typography}>
            <img src={LogoType} alt='Logotype' className={classes.logo} />
            <Typography>
              <Title level={3}>{t('confirmRegistration.title')}</Title>
            </Typography>
          </div>

          <div className={classes.confirmationMessage}>
            <div className={classes.messageText}>
              {t('confirmRegistration.message.part1')}{' '}
              <span className={classes.email}>{email}</span>
              {t('confirmRegistration.message.part2')}
            </div>

            <Button
              type='primary'
              className={classes.resendButton}
              onClick={handleResendEmail}
              loading={isResending}
              disabled={!email || countdown > 0}
            >
              {t('confirmRegistration.resendButton')}
            </Button>

            {countdown > 0 && (
              <div className={classes.timerMessage}>
                {t('confirmRegistration.timer.message', {
                  seconds: countdown,
                })
                  .split('\n')
                  .map((line, index) => (
                    <div key={index}>{line}</div>
                  ))}
              </div>
            )}
          </div>
        </div>

        <Button
          type='primary'
          className={classes.faqButton}
          onClick={handleFaqClick}
        >
          FAQ
        </Button>
      </Layout>
    </div>
  );
}
